module.exports = __webpack_public_path__ + "static/media/brand-story-wap10.6cd46eb6.jpg";